export default [
  'Agriculture et Agroalimentaire Canada',
  'Agence de promotion économique du Canada atlantique',
  'Association des ingénieurs-conseils du Canada',
  'Bell Canada',
  'Agence du revenu du Canada',
  'Programme canadien de prêts aux étudiants',
  'Association des industries canadiennes de défense et de sécurité (AICDS)',
  'Société Radio-Canada',
  'Agence des services frontaliers du Canada',
  'Réseau Entreprises Canada',
  'Fondation canadienne pour les Amériques ',
  'Patrimoine canadien',
  "Association canadienne d'habitation et de rénovation urbaine",
  'Agence spatiale canadienne',
  "L'Association canadienne des producteurs d'acier ",
  'Université Carleton',
  "Société canadienne d'hypothèques et de logement",
  'Agence canadienne de développement international (ACDI)',
  'Ville d’Ottawa',
  'Corporations Canada',
  'Service correctionnel du Canada',
  'CRTC',
  'Exportation et développement Canada',
  'Elections Canada',
  'Emploi et Développement social Canada',
  'Environnement Canada',
  'Agence de la consommation en matière financière du Canada',
  'Financement agricole Canada',
  'FedNor',
  'Finances Canada',
  'Affaires mondiales Canada',
  'Santé Canada',
  'Immigration, Réfugiés et Citoyenneté Canada',
  'Innovation, Sciences et Développement économique Canada / Industrie Canada',
  'Affaires autochtones et du Nord Canada',
  'Bibliothèque et Archives Canada',
  'Monnaie royale canadienne',
  'Métis Nation of Ontario',
  'Hôpital Montfort',
  'Défense nationale / Forces canadiennes',
  'Ressources naturelles Canada',
  'Conseil de recherches en sciences naturelles et en génie (CRSNG)',
  'Gouvernement de l’Ontario (divers ministères ou organismes)',
  'Commissariat à la protection de la vie privée',
  'Santé publique Ottawa',
  'Bibliothèque publique d’Ottawa',
  'Bureau du surintendant des institutions financières',
  'Bureau du directeur parlementaire du budget',
  'Canadian Parents for French',
  'Parcs Canada',
  'Passeport Canada',
  'Agence de la santé publique du Canada',
  'Services publics et Approvisionnement Canada',
  "Commissaire à l'intégrité du secteur public",
  'Sécurité publique Canada ',
  'Services Canada',
  'Sports Canada',
  'Conseil canadien des normes',
  'Bureau de la traduction',
  'Transports Canada',
  'Secrétariat du Conseil du Trésor ',
  'Organisation des Nations Unies',
  'Université d’Ottawa',
  'Anciens Combattants Canada'
];
